import { Checkbox, Col, Input, Radio, RadioChangeEvent, Row } from "antd";
import { useEffect, useState } from "react";
import FormContainer from "../../components/FormContainer/FormContainer";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { useForm } from "../../utility/useForm";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../components/_common/CustomSelect";
import { getState, newPaymentgetwayRequest } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { validateNewPaymentGetwayForm } from "../../utility/validationRules";
import { useAppSelector } from "../../redux/store/storehooks";
import { ValidationErrorSpan } from '../../styles/global';

export interface ValidationTypeProps {
    type: any;
}

interface customProps {
    fileId: number,
    requestId: number,
    labId: number,
    base64File: any,
    fileName: string,
    fileExtension: string,
    isImportant: boolean,
    isDisable: boolean
}

const NewPaymentRequest = () => {
    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(validateNewPaymentGetwayForm) as any
    const [radioVal, setRadioVal] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [stateList, setStateList] = useState([]);
    const [showImg, setShowImg] = useState(false);

    const myStore = useAppSelector((state) => state);

    const navigate = useNavigate();

    const bankList = [
        { bankName: "رفاه" },
        { bankName: "بانک رسالت" },
        { bankName: "صادرات" },
        { bankName: "توسعه تعاون" },
        { bankName: "دی" },
        { bankName: "موسسه اعتباری توسعه" },
        { bankName: "خاورمیانه" },
        { bankName: "ملی ایران" },
        { bankName: "کشاورزی" },
        { bankName: "پست بانک" },
        { bankName: "سامان" },
        { bankName: "گردشگری" },
        { bankName: "ایران زمین" },
        { bankName: "آینده" },

    ];


    const [inputs, setInputs] = useState({
        requestId: 0,
        labId: myStore.auth.userId,
        approveUseId: 0,
        isTestgetway: false,
        isUseParsipolSSl: false,
        desc: "",
        isCompany: true,
        customerName: "",
        nationalCode: "",
        ceoName: "",
        ceoNationalCode: "",
        brithDay: "",
        identityId: "",
        identityserialnumber: "",
        fatherName: "",
        registrationNumber: "",
        companyRegistrationDate: "",
        state: "",
        directTel: "",
        mobileNumber: "",
        email: "",
        accountownername: "",
        bank: "",
        accountNumber: "",
        shabaNumber: "",
        signatureBase64: "",
        myPeymentFiles: [] as any
    });

    const [fileRows, setFileRows] = useState([]);
    const [fileRows1, setFileRows1] = useState([]);


    const ValidationType = ({ type }: ValidationTypeProps) => {
        const ErrorMessage = errors[type];
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    const onChangeRadio = (e: RadioChangeEvent) => {
        console.log('radio checked', e.target.value);
        //setRadioVal(e.target.value);
        setInputs((val: any) => ({
            ...val,
            isCompany: e.target.value
        }))
        setInputs((val: any) => ({
            ...val,
            requestId: 0, labId: myStore.auth.userId, approveUseId: 0
        }))
    };

    const checkedEventChange = (e: any) => {
        setInputs((val: any) => ({
            ...val,
            [e.target.name]: e.target.checked
        }))
    }

    const _handleChange = (e: any) => {
        setInputs((val: any) => ({
            ...val,
            [e.target.name]: e.target.value
        }))
        setValues((val: any) => ({
            ...val,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmitForm = (e: any) => {

        e.preventDefault();
        setIsSubmiting(true);

        setValues(inputs);

        let error = validateNewPaymentGetwayForm(inputs);
        if (Object.keys(error).length == 0) {

            newPaymentgetwayRequest(inputs)
                .then((result: any) => {


                    sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                    navigate("/labuser/RequestPayment");
                    setIsLoading(false);
                    setIsSubmiting(false);


                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)

                })
        }
        else {
            setErrors(error);
            setIsSubmiting(false);

        }


        // newPaymentgetwayRequest(inputs)
        //     .then((result: any) => {


        //         sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
        //         navigate("/labuser/NewPaymentRequestFiles");
        //         setIsLoading(false);

        //     })
        //     .catch((error) => {
        //         console.log(error);
        //         errorNotify(error.response.data.errorMessage, undefined, 5000)

        //     })

        // navigate("/labuser/NewPaymentRequestFiles");
        //  setIsLoading(false);
    }

    const onCancelForm = () => {
        navigate("/labuser/RequestPayment")
    }

    const _getState = () => {

        getState()
            .then((result: any) => {
                setStateList(result.data.data);
                setIsLoading(false);

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)

            })
    }

    const onChange = async (event: any) => {
        const file = event.target.files[0]
        //const base64 = await convertBase64(file)
        setInputs((val: any) => ({
            ...val,
            signatureBase64: file
        }))

        //     const formData = new FormData()

        //     formData.append('file-key', base64)

        //   // --- now you can send base64 file to server --- //
        //     await fetch('api/{your-api-here}', {
        //       method: 'POST',
        //       body:   formData,
        //     })
    }

    const convertToSignatureBase64 = (event: any) => {
        const file = event.target.files[0];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            setInputs((val: any) => ({
                ...val,
                signatureBase64: reader.result
            }));
            setShowImg(true);
            //   setImageData({
            //     base64textString: reader.result,
            //     imageName: file.name,
            //     showImage: true,
            //   });
        };

        reader.onerror = (error) => {
            console.log('Error: ', error);
        };
    };

    const convertToBase64 = (e: any) => {
        const file = e.target.files[0];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            const image: customProps = {
                fileId: 0,
                requestId: 0,
                labId: Number(myStore.auth.userId),
                base64File: reader.result,
                fileName: file.name,
                fileExtension: file.type,
                isImportant: true,
                isDisable: true
            };

            var array = inputs.myPeymentFiles;
            array.push(image);
            setInputs((val: any) => ({
                ...val,
                myPeymentFiles: array
            }));

        };

        reader.onerror = (error) => {
            console.log('Error: ', error);
        };
    };

    const addNewFileRow = () => {
        //var row = " <Col lg={12} md={12} sm={12} xs={12}><span style={{ display: 'ruby' }}> فایل + index.toString()  <input data-index={index} key={index} name='File1Img' placeholder='عکس' onChange={convertToBase64} type='file' accept='image/' /></span></Col>";
        var row = "فایل";
        setFileRows((prevArr: any) => {
            const result: any = [...prevArr];
            result.push(row)
            return result;
        });
    }

    const addNewFileRow1 = () => {
        //var row = " <Col lg={12} md={12} sm={12} xs={12}><span style={{ display: 'ruby' }}> فایل + index.toString()  <input data-index={index} key={index} name='File1Img' placeholder='عکس' onChange={convertToBase64} type='file' accept='image/' /></span></Col>";
        var row = "فایل";
        setFileRows1((prevArr: any) => {
            const result: any = [...prevArr];
            result.push(row)
            return result;
        });
    }

    useEffect(() => {
        _getState();
    }, [])


    return (<>

        <center>
            <Radio.Group
                style={{ marginTop: '15px' }}
                onChange={onChangeRadio} value={inputs.isCompany}>
                <Radio value={true}>حقوقی  </Radio>
                <Radio value={false}>حقیقی  </Radio>
            </Radio.Group>
        </center>


        {inputs.isCompany === true &&
            (
                <FormContainer onSubmit={onSubmitForm} onCancel={onCancelForm} isLoading={isLoading} isSubmiting={isSubmiting} >

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="customerName"
                                placeholder="نام مشتری"
                                value={inputs.customerName || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="customerName" />

                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="nationalCode"
                                placeholder="شناسه ملی "
                                value={inputs.nationalCode || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="nationalCode" />

                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="ceoName"
                                placeholder="نام مدیرعامل "
                                value={inputs.ceoName || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="ceoName" />

                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="ceoNationalCode"
                                placeholder="کد ملی مدیرعامل "
                                value={inputs.ceoNationalCode || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="ceoNationalCode" />

                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="brithDay"
                                placeholder="تاریخ تولد "
                                value={inputs.brithDay || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="brithDay" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="identityId"
                                placeholder="شماره شناسنامه "
                                value={inputs.identityId || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="identityId" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="identityserialnumber"
                                placeholder="سریال شناسنامه"
                                value={inputs.identityserialnumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="identityserialnumber" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="fatherName"
                                placeholder="نام پدر  "
                                value={inputs.fatherName || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="fatherName" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="registrationNumber"
                                placeholder="شماره ثبت"
                                value={inputs.registrationNumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="registrationNumber" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="companyRegistrationDate"
                                placeholder="تاریخ ثبت شرکت"
                                value={inputs.companyRegistrationDate || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="companyRegistrationDate" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomSelect
                                name="state"
                                placeholder="شهر "
                                itemList={stateList}
                                value={inputs.state || ""}
                                onChange={_handleChange}
                                valueObjectField={"prk_State_AutoID"}
                                displayObjectField={"str_StateName"}
                            />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="directTel"
                                placeholder="تلفن ثابت "
                                value={inputs.directTel || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="directTel" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="mobileNumber"
                                placeholder="موبایل"
                                value={inputs.mobileNumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="mobileNumber" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="email"
                                placeholder="ایمیل  "
                                value={inputs.email || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="email" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="accountownername"
                                placeholder="نام صاحب حساب"
                                value={inputs.accountownername || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="accountownername" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomSelect
                                name="bank"
                                placeholder="نام بانک "
                                itemList={bankList}
                                value={inputs.bank || ""}
                                onChange={_handleChange}
                                valueObjectField={"bankName"}
                                displayObjectField={"bankName"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="accountNumber"
                                placeholder="شماره حساب"
                                value={inputs.accountNumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="accountNumber" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="shabaNumber"
                                placeholder="نام شماره شبا"
                                value={inputs.shabaNumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="shabaNumber" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="desc"
                                placeholder="توضیحات"
                                value={inputs.desc || ""}
                                onChange={_handleChange}
                            />
                        </Col>
                    </Row>



                    <Row style={{paddingTop:'20px'}}>
                        <Col lg={12} md={12} sm={12} xs={12}>

                            <span style={{ display: 'ruby' }}>
                                عکس مهر و امضا <input placeholder="عکس" type="file" onChange={convertToSignatureBase64} accept="image/" />
                            </span>

                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            {showImg && (
                                <div>
                                    <img src={inputs.signatureBase64} alt={inputs.signatureBase64} />
                                </div>
                            )}</Col>
                    </Row>
                    <Row style={{paddingTop:'20px'}}>
                        <button onClick={addNewFileRow} type="button"> افزودن فایل جدید</button>                        
                    </Row>

                    <Row style={{paddingTop:'20px'}}>
                    {
                            fileRows.map((entry: any, index: any) => (
                                <Col style={{paddingTop:'10px',paddingLeft:'100px'}} lg={12} md={12} sm={12} xs={12}>
                                    <span style={{ display: 'ruby' }}>
                                        فایل {index + 1}  <input data-index={index} key={index} name="File1Img" placeholder="عکس" onChange={convertToBase64} type="file" accept="image/" />
                                    </span>
                                </Col>
                            ))
                        }
                    </Row>
                    {/* <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <span style={{ display: 'ruby' }}>
                                تصویر شناسنامه  <input data-index={0} key={0} name="File1Img" placeholder="عکس" onChange={convertToBase64} type="file" accept="image/" />
                            </span>
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <span style={{ display: 'ruby' }}>
                                تصویر کارت ملی  <input data-index={1} key={1} name="File2Img" placeholder="عکس" onChange={convertToBase64} type="file" accept="image/" />
                            </span></Col>
                    </Row> */}

                </FormContainer>
            )
        }
        {inputs.isCompany === false &&
            (
                <FormContainer onSubmit={onSubmitForm} isLoading={isLoading} isSubmiting={isSubmiting} >
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="customerName"
                                placeholder=" نام و نام خانوادگی  "
                                value={inputs.customerName || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="customerName" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="nationalCode"
                                placeholder="کد ملی"
                                value={inputs.nationalCode || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="nationalCode" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="fatherName"
                                placeholder="نام پدر "
                                value={inputs.fatherName || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="fatherName" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="brithDay"
                                placeholder="تاریخ تولد"
                                value={inputs.brithDay || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="brithDay" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="identityId"
                                placeholder="شماره شناسنامه"
                                value={inputs.identityId || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="identityId" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="identityserialnumber"
                                placeholder="سریال شناسنامه"
                                value={inputs.identityserialnumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="identityserialnumber" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomSelect
                                name="state"
                                placeholder="شهر "
                                itemList={stateList}
                                value={inputs.state || ""}
                                onChange={_handleChange}
                                valueObjectField={"prk_State_AutoID"}
                                displayObjectField={"str_StateName"}
                            />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="directTel"
                                placeholder="تلفن ثابت "
                                value={inputs.directTel || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="directTel" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="mobileNumber"
                                placeholder="موبایل"
                                value={inputs.mobileNumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="mobileNumber" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="email"
                                placeholder="ایمیل"
                                value={inputs.email || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="email" />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomSelect
                                name="bank"
                                placeholder="نام بانک "
                                itemList={bankList}
                                value={inputs.bank || ""}
                                onChange={_handleChange}
                                valueObjectField={"bankName"}
                                displayObjectField={"bankName"}
                            />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="accountownername"
                                placeholder="نام صاحب حساب"
                                value={inputs.accountownername || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="accountownername" />
                        </Col>
                    </Row>

                    <Row>

                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="accountNumber"
                                placeholder="شماره حساب"
                                value={inputs.accountNumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="accountNumber" />
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <CustomTextArea
                                name="shabaNumber"
                                placeholder="شماره شبا"
                                value={inputs.shabaNumber || ""}
                                onChange={_handleChange}
                            />
                            <ValidationType type="shabaNumber" />
                        </Col>
                    </Row>

                    <Row>



                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="desc"
                                placeholder="توضیحات"
                                value={inputs.desc || ""}
                                onChange={_handleChange}
                            />
                        </Col>


                    </Row>

                    {/* <Row style={{padding:'25px',textAlign:'right'}}>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <Checkbox
                                name="isTestgetway"
                                onChange={(e)=>checkedEventChange(e)}
                                value={inputs.isTestgetway}
                            >
                                {"  آیا درگاه تست شده است؟ "}
                            </Checkbox>
                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <Checkbox
                                name="isUseParsipolSSl"
                                onChange={(e)=>checkedEventChange(e)}
                                value={inputs.isUseParsipolSSl}
                            >
                                {"  آیا از ssl پارسیپل استفاده می کنید؟ "}
                            </Checkbox>
                        </Col>

                    </Row> */}

                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>

                            <span style={{ display: 'ruby' }}>
                                عکس مهر و امضا <input placeholder="عکس" type="file" onChange={convertToSignatureBase64} accept="image/" />
                            </span>

                        </Col>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            {showImg && (
                                <div>
                                    <img src={inputs.signatureBase64} alt={inputs.signatureBase64} />
                                </div>
                            )}</Col>
                    </Row>
                    <Row style={{paddingTop:'20px'}}>
                        <button onClick={addNewFileRow1} type="button"> افزودن فایل جدید</button>                        
                    </Row>

                    <Row style={{paddingTop:'20px'}}>
                    {
                            fileRows1.map((entry: any, index: any) => (
                                <Col style={{paddingTop:'10px',paddingLeft:'100px'}} lg={12} md={12} sm={12} xs={12}>
                                    <span style={{ display: 'ruby' }}>
                                        فایل {index + 1}  <input data-index={index} key={index} name="File1Img" placeholder="عکس" onChange={convertToBase64} type="file" accept="image/" />
                                    </span>
                                </Col>
                            ))
                        }
                    </Row>
                </FormContainer>
            )
        }
    </>)
}

export default NewPaymentRequest;